<ion-content class="safe-area-top white">


  <div class="content-spacing px-md">

    <div class="ts-body-bold pt-sm" [innerHTML]="'CONSENT.HEADER' | translate"></div>
    <div class="ts-caption pt-md" [innerHTML]="'CONSENT.DESCRIPTION' | translate"></div>

    <div class="mt-md d-flex flex-column gap-2">

      <div class="d-flex gap-2">
        <ion-icon class="text-green-500"
                  name="checkmark-done-outline"></ion-icon>
        <div class="ts-caption">{{ 'CONSENT.Dati anonimi, non ti identificano' | translate }}</div>
      </div>

      <div class="d-flex gap-2">
        <ion-icon class="text-green-500"
                  name="checkmark-done-outline"></ion-icon>
        <div  class="ts-caption">{{ 'CONSENT.Nessuna condivisione per pubblicità' | translate }}</div>
      </div>

      <div class="d-flex gap-2">
        <ion-icon class="text-green-500"
                  name="checkmark-done-outline"></ion-icon>
        <div  class="ts-caption">{{ 'CONSENT.Puoi disattivare quando vuoi' | translate }}</div>
      </div>

    </div>

    <div class="d-flex flex-column gap-2 mt-xxl">

      <ion-button (click)="accept()"
                  class="w-100 success small">
        <span class="material-symbols-outlined pr-sm">check_circle</span>
        <span>{{ 'Accetta' | translate }}</span>
      </ion-button>

      <ion-button (click)="decline()"
                  fill="clear"
                  class="w-100 secondary small">
        <span class="material-symbols-outlined pr-sm">block</span>
        <span>{{ 'Rifiuta' | translate }}</span>
      </ion-button>

    </div>

  </div>

</ion-content>


